import React from "react";
import { MessageCircle } from "lucide-react";

// Floating WhatsApp chat button.
const WHATSAPP_NUMBER = "919899250725";
const MESSAGE = "Hi OOHMA, I'd like to know more about your services.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      style={{
        position: "fixed",
        right: 22,
        bottom: 22,
        zIndex: 60,
        width: 58,
        height: 58,
        borderRadius: "50%",
        background: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 12px 30px -8px rgba(37,211,102,0.6)",
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.08)";
        e.currentTarget.style.boxShadow = "0 16px 40px -8px rgba(37,211,102,0.75)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 12px 30px -8px rgba(37,211,102,0.6)";
      }}
    >
      <MessageCircle size={28} color="#fff" fill="#fff" strokeWidth={0} />
      <span
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          border: "2px solid #25D366",
          animation: "wa-ping 2s cubic-bezier(0,0,0.2,1) infinite",
        }}
      />
      <style>{`@keyframes wa-ping{0%{transform:scale(1);opacity:0.7}80%,100%{transform:scale(1.7);opacity:0}}`}</style>
    </a>
  );
};

export default WhatsAppButton;
